import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Devora Fuente',
    location: 'Atlanta, GA',
    content: 'I booked with them in April and chose the Tiny Tot Package, He was turning 1 and my little one loved it! I definitely recommend them they are flexible and I love how easy they make it! 😊\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjWcCdZfy9uykczlg7BZusnK_73YTWN8nZIgsjpC4ZlGPDoEeRd2=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Sandy Parker',
    location: 'Newnan, GA',
    content: "What a great experience! We rented the Megatot set up for my granddaughter's 2nd birthday party with kids ranging from 1-4 with 14 children. Everyone had a great time…not a single meltdown! All played happily! The kind people at Toddler Time were great to deal with! Great communication regarding set up and breakdown. Can't recommend them highly enough!! Great value!!!",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocKh8WnTjumiTp8Jxs3sW6WCCbHaMufugXN5g4p4tVF5R3HBcg=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Savannah Easton',
    location: 'Roopville, GA',
    content: "The perfect addition to our daughter's birthday! The family was super sweet and arrived early for setup. The kids had a blast and we will be renting from them again!\n\n\n\n\n",
    image: 'https://lh3.googleusercontent.com/a-/ALV-UjXN6CGzwfI_sCRAGJpmnJ5Xc5WoxPyLxjBYUeMAjRFFrF1a_ubk9Q=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Cassidi Mapp',
    location: 'Conyers, GA',
    content: "I had a great experience booking with Toddler Time for my daughter's 1st birthday party. Their communication was top tier & they were on time for arrival and departure. Although my daughter is pretty young and did not enjoy it as much, there were plenty of other children at the party that had a ball! It definitely keeps them occupied. I 100% recommend booking with Toddler Time!",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocKJ4m68dmrDLzSHPlYJCTjmQnHlaqbpq82Z66uM7ky7_s5AFw=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Laura Avellanda',
    location: 'Ellenwood, GA',
    content: "I love it! I got the mega tot package for my baby's first year birthday and it was a hit! All of the kids really enjoyed it. You should book with them because : - everything was so clean and well maintained. - they arrived on time to do the set up before the party started . - Christine and her husband were so nice , great customer service. - they have the best price for the package compare with other vendors. I will book with them again !❤️",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocI_1vQinX3YngD2UMBYlqZqsw6vvhQx6HXvxauiiAYO3M7LpQ=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Lyric Thomason',
    location: 'Dallas, GA',
    content: "Toddler time came and set up the mega tot package at my son's first birthday party. It was a blast. They were so friendly, quick, and easy. Thank you for making my son's first birthday something we will never forget! 100% recommend for any toddler parties or event 🎉\n\n",
    image: 'https://lh3.googleusercontent.com/a/ACg8ocK_ELAxUSJ8BaCCTqJg0azRfpeR5DuJNmJ4UwEocHztLXinDQ=w144-h144-p-rp-mo-br100'
  }, {
    name: 'Jasmin Moon',
    location: 'Atlanta, GA',
    content: 'Professional and awesome! Definitely would recommend and/or book with again!\n\n\n\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocIipLRzJDTV302-J0Tcf9cOs6VEXFdWh951WTKjWR_YhBJ3fw=w144-h144-p-rp-mo-ba2-br100'
  }, {
    name: 'Rekya Sanders',
    location: 'Marietta, GA',
    content: 'Very nice and professional! Loved the services and will use again! Thank you for making my daughter birthday special!\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocI8Hl5w-VSWkq3OMFBp2ppQqopeSaCvMWUlbFiWDol7kGghwQ=w144-h144-p-rp-mo-ba2-br100'
  }, {
    name: 'Regina Martin',
    location: 'Atlanta, GA',
    content: 'They were excellent at responding in a timely manner! They worked with my schedule and made my day successful\n\n\n\n\n\n',
    image: 'https://lh3.googleusercontent.com/a/ACg8ocJGm9Omt59Wx4WrfLsn1uihfCJp-VOF9NuOZYy9JkM_3qIXy7CY=w144-h144-p-rp-mo-br100'
  }];
  // State to track current testimonial index
  const [currentIndex, setCurrentIndex] = useState(0);
  // State to track if we're on mobile
  const [isMobile, setIsMobile] = useState(false);
  // Check if we're on mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);
  // Auto-slide functionality
  useEffect(() => {
    const autoSlideInterval = setInterval(() => {
      goToNext();
    }, 5000); // Slide every 5 seconds
    // Clear interval when component unmounts
    return () => {
      clearInterval(autoSlideInterval);
    };
  }, [currentIndex, isMobile]);
  // Function to go to next testimonial
  const goToNext = () => {
    if (isMobile) {
      setCurrentIndex(prevIndex => prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1);
    } else {
      setCurrentIndex(prevIndex => prevIndex === testimonials.length - 3 ? 0 : prevIndex + 1);
    }
  };
  // Function to go to previous testimonial
  const goToPrev = () => {
    if (isMobile) {
      setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
    } else {
      setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 3 : prevIndex - 1);
    }
  };
  // Get current testimonials to display (3 on desktop, 1 on mobile)
  const getCurrentTestimonials = () => {
    if (isMobile) {
      return [testimonials[currentIndex]];
    } else {
      return [testimonials[currentIndex], testimonials[(currentIndex + 1) % testimonials.length], testimonials[(currentIndex + 2) % testimonials.length]];
    }
  };
  // Handle touch events for swiping on mobile
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) {
      goToNext();
    }
    if (isRightSwipe) {
      goToPrev();
    }
    setTouchStart(null);
    setTouchEnd(null);
  };
  return <section id="testimonials" className="bg-gray-50 py-16 md:py-24 border-t border-gray-100" data-id="element-341">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342">
        <div className="text-center mb-16" data-id="element-343">
          <h2 className="text-4xl font-bold text-gray-900" data-id="element-344">
            Happy Parents & Kids
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-500" data-id="element-345">
            Don't just take our word for it - see what Atlanta families have to
            say
          </p>
        </div>
        <div className="relative" data-id="element-346">
          {/* Testimonials grid/carousel */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-347">
            {getCurrentTestimonials().map((testimonial, index) => <div key={index} className="bg-white rounded-3xl shadow-md overflow-hidden p-8 relative transition-all duration-500 ease-in-out flex flex-col h-[600px] md:h-[700px]" data-id="element-348">
                {/* Large quote marks in top right */}
                <div className="absolute top-4 right-4 text-8xl text-gray-100 opacity-50 leading-none" data-id="element-349">
                  ❞
                </div>
                {/* Profile section with image and details */}
                <div className="flex items-start mb-6 relative z-10" data-id="element-350">
                  <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full mr-4 object-cover" data-id="element-351" />
                  <div data-id="element-352">
                    <h3 className="text-2xl font-bold text-gray-900" data-id="element-353">
                      {testimonial.name}
                    </h3>
                    <p className="text-gray-500 text-lg" data-id="element-354">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
                {/* Stars */}
                <div className="flex mb-6" data-id="element-355">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-6 h-6 text-yellow-300 fill-current mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-id="element-356">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-357" />
                    </svg>)}
                </div>
                {/* Testimonial content */}
                <p className="text-gray-600 italic text-lg leading-relaxed flex-grow whitespace-pre-line" data-id="element-358">
                  {testimonial.content}
                </p>
              </div>)}
          </div>
          {/* Mobile pagination indicators */}
          {isMobile && <div className="flex justify-center mt-6 space-x-2" data-id="element-359">
              {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2.5 h-2.5 rounded-full ${currentIndex === index ? 'bg-primary-500' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-360" />)}
            </div>}
          {/* Navigation arrows */}
          <div className={`flex justify-between items-center mt-10 ${isMobile ? 'px-4' : ''}`} data-id="element-361">
            <button onClick={goToPrev} className="p-3 rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors" aria-label="Previous testimonials" data-id="element-362">
              <ChevronLeftIcon className="h-6 w-6" data-id="element-363" />
            </button>
            <button onClick={goToNext} className="p-3 rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors" aria-label="Next testimonials" data-id="element-364">
              <ChevronRightIcon className="h-6 w-6" data-id="element-365" />
            </button>
          </div>
          {/* View all testimonials link */}
          <div className="text-center mt-12" data-id="element-366">
            <Link to="/testimonials" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600 transition" onClick={() => window.scrollTo(0, 0)} data-id="element-367">
              View All Testimonials
            </Link>
          </div>
        </div>
      </div>
    </section>;
};